import clsx from "clsx";
import { useReducer, useState, useRef, useEffect } from "react";

export default function QuestionBlock(
    {
        question = "",
        answer = ""
    }
){
    const [active,setActive] = useState(false);
    const [maxHeight,setMaxHeight] = useState(null);
    const answerContainer = useRef(null);

    useEffect(()=>{
        setMaxHeight(answerContainer.current.offsetHeight);
    },[]);

    return (
        <div className="bg-white w-full px-[1.5rem] py-[1.25rem] text-black flex flex-col">
            <div className="flex justify-between items-center">
                <h4 className="font-[500] text-heading-6">
                    {question}
                </h4>
                <button className={clsx(
                    "min-w-[1.375rem] ml-3 aspect-square relative after:content-[''] after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:w-full after:h-[4px] after:bg-black before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:h-full before:w-[4px] before:bg-black before:transition-all",
                    active && "before:rotate-90"
                )}
                onClick={()=>{
                    setActive(!active);
                }}>
                </button>
            </div>
            <div className="overflow-hidden transition-all" ref={answerContainer}
            style={
                {
                    maxHeight: maxHeight && `${active ? maxHeight : 0}px`,
                }
            }>
                <p>
                    {answer }
                </p>
            </div>
        </div>
    )
}